import { render } from "./ProjectsList.vue?vue&type=template&id=9184fd82&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"

import "./ProjectsList.vue?vue&type=style&index=0&id=9184fd82&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9184fd82"]])

export default __exports__